export default __webpack_public_path__ + "static/media/github.946006d8.svg";